import { createApp } from '@app/adapters/create-app'

import WorkflowReviewSecondaryRight from '@app/application/workflows/screens/workflow-review/components/workflow-review-subnav-secondary-right.vue'

window.onDomLoad(function ($dom) {
  $dom
    .find("[data-behaviour='workflow-review-subnav-secondary-right']")
    .each(function () {
      const data = this.dataset

      const app = createApp(WorkflowReviewSecondaryRight, {
        ledgerId: data.ledgerId ? parseInt(data.ledgerId, 10) : -1,
        workflowId: data.workflowId ? parseInt(data.workflowId, 10) : -1,
      })

      app.mount(this)
    })
})
